import React, { useState } from "react"
import { Container } from "reactstrap"
import "./MykaV2Faq.scss"

const ChevronIcon = ({ isOpen }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={`myka-v2-faq__chevron-svg${isOpen ? " myka-v2-faq__chevron-svg--open" : ""}`}
  >
    <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const MykaV2Faq = ({ faqHeading, faqs = [], faqCtaLabel }) => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i)

  return (
    <section className="myka-v2-faq">
      <Container>
        {faqHeading && (
          <h2 className="myka-v2-faq__heading">{faqHeading}</h2>
        )}

        <div className="myka-v2-faq__accordion">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i
            return (
              <div key={item.question} className="myka-v2-faq__item">
                <button
                  type="button"
                  className={`myka-v2-faq__question${isOpen ? " myka-v2-faq__question--open" : ""}`}
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                >
                  <span className="myka-v2-faq__question-text">{item.question}</span>
                  <span className="myka-v2-faq__chevron-wrap">
                    <ChevronIcon isOpen={isOpen} />
                  </span>
                </button>

                {isOpen && item.answer && (
                  <div
                    className="myka-v2-faq__answer"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                )}
              </div>
            )
          })}
        </div>

        <div className="myka-v2-faq__cta-wrap">
          <button type="button" className="myka-v2-faq__cta open-chat-btn">
            {faqCtaLabel || "Get answers!"}
          </button>
        </div>
      </Container>
    </section>
  )
}

export default MykaV2Faq
